import React, { Component } from "react"
import { Container, Row, Col } from 'reactstrap'
import SubscriptionsListHeader from "./SubscriptionsListHeader"
import SubscriptionsList from "./SubscriptionsList"
import ListingTabs from "../../Material/ListingTabs"
import ReportsPanel from "../../Reports/ReportsPanel"
import { buildPresets } from "../../Filters/presetFilters"

// Editable, visible default: the list opens showing Active + Past Due subscriptions.
// "1"/"2" are the raw model values -- NOT the graphene enum names.
const STATUS_PRESET = [
    { fieldName: "status", filterType: "in", filterValues: ["1", "2"], editable: true, visible: true },
]

// Stable identity, built once: setPresets only ever touches state.presets, so
// this is untouched by user edits and is what Reset returns to.
const DEFAULT_PRESETS = buildPresets(STATUS_PRESET)

// No URL hash routing here -- this page never had tabs before, so there is
// nothing to preserve deep links for. Local state is enough.
const SUBSCRIPTIONS_LISTING_TABS = [
    { id: "#all", name: "Subscriptions" },
    { id: "#reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
]

class SubscriptionsContainer
    extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: {
                orderBy: ["-id"]
            },
            presets: DEFAULT_PRESETS,
            refetchCustomers: false,
            selectedCustomers: [],
            activeTab: SUBSCRIPTIONS_LISTING_TABS[0].id,
        }
    }

    changeTab = (tabId) => this.setState({ activeTab: tabId })
    setPresets = (presets) => this.setState({ presets })

    updateOrder = (string) => {
        let order = this.state.filterValues.orderBy ? [...this.state.filterValues.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState((prevState) => ({ filterValues: { ...prevState.filterValues, orderBy: order } }))
    };

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={SUBSCRIPTIONS_LISTING_TABS}
                    activeTab={this.state.activeTab}
                    onChange={this.changeTab}
                />
                {this.state.activeTab !== "#reports" && <SubscriptionsListHeader
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={DEFAULT_PRESETS}
                    currentUser={this.props.currentUser}
                />}
                <Row>
                    <Col>
                        {this.state.activeTab === "#reports" ?
                            <ReportsPanel reportId="subscriptions" />
                            :
                            <SubscriptionsList
                                key={String(this.state.refetchCustomers)}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                currentUser={this.props.currentUser}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                presets={this.state.presets}
                            />}

                    </Col>
                </Row>
            </Container>

        )
    }
}

export default SubscriptionsContainer
